import { Component, OnInit, OnDestroy } from '@angular/core';
import { Encrypted, Configuration } from 'src/app/Constants/configuration';
import { EmisionService } from 'src/app/services/emision.service';
import { RequestServices } from 'src/app/services/request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Cancelacion } from '../../modelos/cancelacion.model';
import { Endoso } from '../../modelos/endoso.model';
import { Adjunto } from '../../modelos/adjunto.model';
import { MatDialog } from '@angular/material/dialog';
import { SimpleMessageComponent } from 'src/app/tools/simple-message/simple-message.component';
import { Cias } from '../../modelos/cias.model';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { StorageService } from 'src/app/services/storage.service';
import { Prospecto } from 'src/app/modelos/prospecto.model';
import { Compartir } from '../../modelos/compartir.model';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { LogConsumoFunciones } from 'src/app/utilities/logConsumo';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';
declare var gtag;

@Component({
  selector: 'app-pago-en-linea',
  templateUrl: './pago-en-linea.component.html',
  providers: [RequestServices]
})
export class PagoEnLineaComponent implements OnInit, OnDestroy {
  private configuration: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  public ec: Encrypted = new Encrypted();
  cancel: Cancelacion = new Cancelacion();
  endoso: Endoso = new Endoso();
  adjunto: Adjunto = new Adjunto();
  cias: Cias = new Cias();
  prospecto: Prospecto = new Prospecto();
  compartir: Compartir = new Compartir();
  public validando: Number = 1;
  public mensajeResponse: string = '';
  public subscribe;
  public parameters: Array<any> = new Array<any>();
  public emisionService: EmisionService;
  public notificacionService: NotificacionService = new NotificacionService(this.requestService);
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  private jsonSave = {
    reciboId: '',
    base: {
      emisionId: 0,
      ciaId: 0,
      ciaString: '',
      clienteId: 0,
      noPoliza: '',
      worksiteId: 0
    },
    total: '',
    liquidacion: '',
    documento: '',
    formaCobro: 0,
    comentario: '',
    fecPago: '',
    pagoId: 0, // pagoId de quattroAutos
    refProg: '', // referencia para pago domiciliado, TipOP = 1, 2
    reciboIdComplemento: ''
  }
  private cocheSeguro: CocheSeguro = new CocheSeguro();
  private modeloCorreo: number;

  constructor(private requestService: RequestServices, private route: ActivatedRoute, private router: Router, private http: HttpClient, private dialog: MatDialog, private storageService: StorageService) {
    this.emisionService = new EmisionService(http, this.requestService);
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
  }

  ngOnInit(): void {
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      switch (this.cocheSeguro.paquete) {
        case 0: // AMPLIA
          this.modeloCorreo = 23;
          break;
        case 1: // LIMITADA
          this.modeloCorreo = 24;
          break;
        case 2: // BÁSICA
          this.modeloCorreo = 24;
          break;
      }
    }
    if (this.cocheSeguro?.prospecto) {
      this.prospecto = this.cocheSeguro.prospecto;
    }
    this.parameters = [];
    this.subscribe = this.route.queryParams.subscribe(params => {
      if (params) {
        this.parameters.push(params);

        if (this.parameters[0].Aut) {
          if (!isNaN(Number(this.parameters[0].Aut))) {
            const statusAuth = Number(this.parameters[0].Aut);
            this.pagoExitoso(statusAuth);
            switch (statusAuth) {
              // Comentarios en base a la documentación de ChubbPagosUI
              case 0: case 4: case 5: case 6:
                // 0 - Rechazado/Salida del Usuario.
                // 4 - Salida de Usuario del sistema por intento máximo permitido.
                // 5 - No se encontró monto a cobrar/No existe la póliza en cobranza.
                // 6 - No se pudo iniciar la aplicación de Cargos en línea.
                this.logConsumoFun.logConsumo(66);// PASO INSERTADO COMO "COMPRA INCONCLUSA"
                setTimeout(() => {
                  if (this.storageService.ifExist("logConsumoId")) {
                    this.storageService.removeItem("logConsumoId");
                  }
                }, 500);

                this.endosoCancelacion();
                break;
              case 1:
                // 1 - Aprobado. (Cargo o Programación de manera individual)
                this.logConsumoFun.logConsumo(77); // PASO INSERTADO COMO "COMPRA EXITOSA"
                gtag({ 'event': 'formStep5Submit' });
                this.cocheSeguro.polizaIdEnc = this.parameters[0].pol;
                this.cocheSeguro.opcion = this.cocheSeguro.paquete;
                this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                this.updatelogConsumo();
                setTimeout(() => {
                  if (this.storageService.ifExist("logConsumoId")) {
                    this.storageService.removeItem("logConsumoId");
                  }
                }, 1000);
                if (isNaN(Number(this.parameters[0].TipOp))) {
                  // error
                  this.realizaImpresion();
                  this.creacionPolINBROKER();
                } else {
                  // TipOP - Tipo Operacion
                  // 0 - Pagar
                  // 1 - Programar
                  // 2 - Pagar y Programar
                  // 3 - Salida del Usuario
                  const tipoOperacion = Number(this.parameters[0].TipOp);
                  switch (tipoOperacion) {
                    case 0:
                      // WSVENTASPAG (pagar, se cobra en línea solo lo vencido al día en que se llama la ventana)
                      this.setJsonData();
                      this.creacionPolINBROKER();
                      break;
                    case 1:
                      // tslint:disable-next-line: max-line-length
                      // WSVENTASPROG (programa todos los recibos para cobro (si no se tiene calendario de pago el cobro se hace al inicio de vigencia del recibo)
                      // api actualiza recibos
                      this.actualizaRefRecibos();
                      this.creacionPolINBROKER();
                      break;
                    case 2:
                      // WSVENTASPYP (cobra en línea los vencido (regularmente primer recibo) y programa el resto)
                      this.creacionPolINBROKER();
                      break;
                    case 3:
                      break;
                  }
                }
                break;
              case 2: // 2 - Cargo Aprobado, Programación Aprobada. 
                this.logConsumoFun.logConsumo(77); // PASO INSERTADO COMO "COMPRA EXITOSA"
                gtag({ 'event': 'formStep5Submit' });
                this.cocheSeguro.polizaIdEnc = this.parameters[0].pol;
                this.cocheSeguro.opcion = this.cocheSeguro.paquete;
                this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                this.updatelogConsumo();
                setTimeout(() => {
                  if (this.storageService.ifExist("logConsumoId")) {
                    this.storageService.removeItem("logConsumoId");
                  }
                }, 1000);
                this.actualizaRefRecibosAlter();
                this.creacionPolINBROKER();
                break;
              case 3: // 3 - Cargo Aprobado, Programación Rechazada.
                this.logConsumoFun.logConsumo(77); // PASO INSERTADO COMO "COMPRA EXITOSA"
                gtag({ 'event': 'formStep5Submit' });
                this.cocheSeguro.polizaIdEnc = this.parameters[0].pol;
                this.cocheSeguro.opcion = this.cocheSeguro.paquete;
                this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                this.updatelogConsumo();
                setTimeout(() => {
                  if (this.storageService.ifExist("logConsumoId")) {
                    this.storageService.removeItem("logConsumoId");
                  }
                }, 1000);
                this.setJsonData();
                this.creacionPolINBROKER();
                break;
            };
          } else {
            this.pagoExitoso(0);
            this.realizaImpresion();
          }
        } else {
          this.pagoExitoso(0);
          this.realizaImpresion();
        }
      } else {
        this.realizaImpresion();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscribe.unsubscribe();
  }

  pagoQuattro() {
    /**Pago de recibo póliza principal */
    this.emisionService.generaPagoPrimerRecibo({
      reciboId: this.jsonSave.reciboId,
      base: {
        emisionId: this.jsonSave.base.emisionId,
        ciaId: this.jsonSave.base.ciaId,
        ciaString: this.jsonSave.base.ciaString,
        clienteId: this.jsonSave.base.clienteId,
        noPoliza: this.jsonSave.base.noPoliza,
        worksiteId: this.jsonSave.base.worksiteId
      },
      total: this.jsonSave.total,
      liquidacion: this.jsonSave.liquidacion,
      documento: this.jsonSave.documento,
      formaCobro: 0,
      comentario: this.jsonSave.comentario,
      fecPago: this.jsonSave.fecPago
    });
    /**Pago de recibo póliza complemento */
    this.emisionService.generaPagoPrimerRecibo({
      reciboId: this.jsonSave.reciboIdComplemento,
      base: {
        emisionId: this.jsonSave.base.emisionId,
        ciaId: this.jsonSave.base.ciaId,
        ciaString: this.jsonSave.base.ciaString,
        clienteId: this.jsonSave.base.clienteId,
        noPoliza: this.jsonSave.base.noPoliza,
        worksiteId: this.jsonSave.base.worksiteId
      },
      total: '0',
      liquidacion: this.jsonSave.liquidacion,
      documento: this.jsonSave.documento,
      formaCobro: 0,
      comentario: this.jsonSave.comentario,
      fecPago: this.jsonSave.fecPago
    });
    this.realizaImpresion();
  }

  goMiCuenta() {
    if (this.configuration.PLATFORM) {
      window.location.href = this.configuration.URLPLATFORM + 'mi-cuenta';
    } else {
      this.router.navigate(['mi-cuenta']);
    }
  }

  setJsonData() {
    if (this.parameters[0].Liq) {
      this.jsonSave.liquidacion = this.parameters[0].Liq;
    }
    if (this.parameters[0].NAut) {
      this.jsonSave.documento = this.parameters[0].NAut;
    }
    if (this.parameters[0].rid) {
      this.jsonSave.reciboId = this.parameters[0].rid;
    }
    if (this.parameters[0].clid) {
      this.jsonSave.base.clienteId = Number(this.parameters[0].clid);
    }
    if (this.parameters[0].wid) {
      this.jsonSave.base.worksiteId = Number(this.parameters[0].wid);
    }
    if (this.parameters[0].cia) {
      this.jsonSave.base.ciaString = this.parameters[0].cia;
    }
    if (this.parameters[0].eid) {
      this.jsonSave.base.emisionId = Number(this.parameters[0].eid);
    }
    if (this.parameters[0].cid) {
      this.jsonSave.base.ciaId = Number(this.parameters[0].cid);
    }
    if (this.parameters[0].tot) {
      this.jsonSave.total = this.parameters[0].tot;
    }
    if (this.parameters[0].pid) {
      this.jsonSave.pagoId = Number(this.parameters[0].pid);
    }
    if (this.parameters[0].pol) {
      this.jsonSave.base.noPoliza = this.parameters[0].pol;
    }
    if (this.parameters[0].RefProg) {
      this.jsonSave.refProg = this.parameters[0].RefProg;
    }
    if (this.parameters[0].ridCom) {
      this.jsonSave.reciboIdComplemento = this.parameters[0].ridCom;
    }

    this.jsonSave.comentario = this.getComentario();
    this.jsonSave.fecPago = this.getFecha();

    this.pagoQuattro();
  }

  getComentario(): string {
    let comentarioStr = '';
    if (this.parameters[0].Aut) {
      comentarioStr += 'Estatus de la autorización: ' + this.parameters[0].Aut;
    }
    if (this.parameters[0].Liq) {
      comentarioStr += '\nNúmero de liquidación: ' + this.parameters[0].Liq;
    }
    if (this.parameters[0].NAut) {
      comentarioStr += '\nNúmero de autorización bancaria: ' + this.parameters[0].NAut;
    }
    if (this.parameters[0].TipOp) {
      comentarioStr += '\nTipo de operación realizada: ' + this.parameters[0].TipOp;
    }
    if (this.parameters[0].RefProg) {
      comentarioStr += '\nNúmero de referencia: ' + this.parameters[0].RefProg;
    }

    return comentarioStr.trim();
  }

  getFecha() {
    let fecStr = '';
    try {
      const now = new Date();
      fecStr += now.getFullYear().toString();
      fecStr += '-' + (((now.getMonth() + 1) < 10) ? ('0' + (now.getMonth() + 1)) : now.getMonth() + 1);
      fecStr += '-' + ((now.getDate() < 10) ? ('0' + now.getDate()) : now.getDate());
      fecStr += ' ' + ((now.getHours() < 10) ? ('0' + now.getHours()) : now.getHours());
      fecStr += ':' + ((now.getMinutes() < 10) ? ('0' + now.getMinutes()) : now.getMinutes());
      fecStr += ':' + ((now.getSeconds() < 10) ? ('0' + now.getSeconds()) : now.getSeconds());
    } catch (error) {
      fecStr = '';
    }
    return fecStr;
  }

  private realizaImpresion() {
    //this.goMiCuenta();
    this.emisionService.generaImpresionAdjuntoAsync(
      {
        basic: {
          emisionId: Number(this.parameters[0].eid),
          ciaId: Number(this.parameters[0].cid),
          ciaString: this.parameters[0].cia,
          clienteId: Number(this.parameters[0].clid),
          noPoliza: '',
          worksiteId: Number(this.parameters[0].wid)
        },
        cotizacionId: 0,
        conductor: '',
        polizaId: this.parameters[0].pol
      }).subscribe(
        result => {

          if (result.error) {
            console.error(result.error);
            this.validando = 0;
            this.goMiCuenta();
          } else {
            this.validando = 0;
            this.compartirMiPoliza();
            this.compartirCaraturaPoliza(this.parameters[0].pol, new Configuration().worksiteIdEncr, this.cocheSeguro.prospecto.correo, this.modeloCorreo);
            this.goMiCuenta();
          }
        }, error => {
          console.error("Ocurrió un problema durante el proceso", error);
          this.validando = 0;
          this.goMiCuenta();
        });
  }

  endosoCancelacion() {
    this.cancel.polizaId = this.parameters[0].pol;
    this.cancel.polizaIdComplemento = this.parameters[0].polCom;
    this.cancel.razon = "Cancelación por falta de pago:";
    this.cancel.motivo = "Cancelación por pago declinado";
    this.cancel.aplicarEndoso = false;
    this.cancel.opcion = 1;
    this.cancelacion();
  }

  cancelacion() {
    try {
      this.requestService.postRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "MarketCancelacionAutoAPI", dataJSON: this.cancel })
        .subscribe(
          resultado => {
            if (resultado.error) {
              console.error("result.error2: ", resultado.error);
            } else {
              this.endoso.aseguradoraId = this.parameters[0].cid;
              this.endoso.tipoEndoso = 1;
              this.endoso.negocio = this.parameters[0].neg;
              this.endoso.polizaId = this.parameters[0].pol;
              this.requestService.postRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "Sio4EndosoEmisionAPI", dataJSON: this.endoso })
                .subscribe(result => {
                  if (result.error) {
                    this.notificacionService.notificacionCRM({
                      url: this.cocheSeguro.url, aseguradoraID: this.parameters[0].cia, clienteID: this.parameters[0].cli, emisionID: this.parameters[0].eid.toString(), msgError: result.error
                    });
                    this.goMiCuenta();
                  } else {
                    this.notificacionService.notificacionCRM({
                      url: this.cocheSeguro.url, aseguradoraID: this.parameters[0].cia, clienteID: this.parameters[0].cli, emisionID: this.parameters[0].eid.toString(), msgError: result.error
                    });
                    if (result.em_Endoso.ok) {
                      try {
                        this.cancel.endoso = result.em_Endoso.no_endoso;
                        this.cancel.endosoId = resultado.endoso_id;
                        this.cancel.aplicarEndoso = true;
                        this.cancel.endosoIdComplemento = resultado.complemento.endoso_id;
                        this.requestService.postRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "MarketCancelacionAutoAPI", dataJSON: this.cancel })
                          .subscribe(
                            resultCancela => {
                              if (resultCancela.error) {
                                console.error("result.error2: ", resultCancela.error);
                                this.goMiCuenta();
                              } else {
                                let u = 0;
                                if (result.em_Endoso.impresion != null) {
                                  for (let i = 0; i < result.em_Endoso.impresion.length; i++) {
                                    let _url: string = result.em_Endoso.impresion[i].pdf;
                                    let x: string = _url.split("/")[_url.split("/").length - 1];
                                    this.adjunto.c2 = _url;
                                    this.adjunto.c3 = result.em_Endoso.impresion[i].nombre_original;
                                    this.adjunto.c6 = x;
                                    this.adjunto.c8 = resultCancela.endoso_id;
                                    this.adjunto.c14 = true;
                                    this.uploadPDFAdjunto();
                                    u++;
                                  }
                                  if (result.em_Endoso.impresion.length === u) {
                                    this.goMiCuenta();
                                  }
                                } else {
                                  this.goMiCuenta();
                                }
                              }
                            }, error => {
                              console.error("error en cancelacion de segunda", error);
                            }
                          );
                      } catch (ex) {
                        console.error(ex);
                      }
                      this.goMiCuenta();
                    } else if (result.error) {
                      let menssage = this.dialog.open(SimpleMessageComponent);
                      menssage.componentInstance.accion = "Aceptar";
                      menssage.componentInstance.message = result.error;
                    }
                  }
                }, error => {
                  console.error("Error => ", error);
                });
            }
          }, error => {
            console.error("error en cancelacion de segunda");
          }
        );
    } catch (ex) {
      console.error(ex);
    }
  }

  uploadPDFAdjunto() {
    try {

      this.requestService.postRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "Sio4AdjuntoAPI", dataJSON: this.adjunto }).subscribe(
        result => {
          if (result.error) {
            console.error("error", result.error);
          } else {
            if (result.ok) {

            }
          }
        }, error => {
          console.error("error:", error);
        }
      );
    } catch (error) {
      console.error("error:", error);
    }
  }

  compartirMiPoliza() {
    /* Se agrego, pero como aun no se usa en el componente de datos-tarjeta, se dejo hasta alli */
    try {
      this.compartir.v1 = this.prospecto.correo;
      this.compartir.v2.push({ 'c1': this.parameters[0].pol, 'c3': 1 }, { 'c1': this.parameters[0].polCom, 'c3': 1 });
      this.compartir.pid = this.parameters[0].polid;
      this.requestService.postRequest({ projectName: new Configuration().URLMIPOLIZA, apiName: 'MiPolizaCompartePolizasAPI', dataJSON: this.compartir }).subscribe(
        result => {
          if (result.error) {
            console.error("error => ", result.error);
          } else {
          }
        }, error => {
          console.error("error => ", error);
        }
      )
    } catch (error) {
      console.error("error: ", error);
    }
  }

  compartirCaraturaPoliza(polizaIdEnc: string, worksiteIdEnc: string, email: string, modelo: number) {
    try {
      this.requestService.getRequest({ projectName: new Configuration().URLPOLIZAS, apiName: 'Sio4CorreoModeloCocheSeguroAPI', params: [{ v1: polizaIdEnc }, { v2: modelo }] }).subscribe(
        result => {
          if (result.error) {
            console.error('Ocurrió un problema durante el proceso', result.error);
          }
        }, error => {
          console.error('Ocurrió un problema durante el proceso', error);
        }
      )
    } catch (error) {
      console.error('Ocurrió un problema durante el proceso', error);
    }
  }

  private actualizaRefRecibos() {
    try {

      const data = {
        "polizaId": this.parameters[0].pol,
        "refProg": this.parameters[0].RefProg
      };
      this.requestService.postRequestAsync({ projectName: new Configuration().URLPOLIZAS, apiName: "Sio4ActualizaReferenciaReciboAPI", dataJSON: data });
    } catch (e) {
      console.error("Exception in actualizaRefRecibos " + e);
    }
    this.realizaImpresion();
  }

  private actualizaRefRecibosAlter() {
    try {

      const data = {
        "polizaId": this.parameters[0].pol,
        "refProg": this.parameters[0].RefProg
      };
      this.requestService.postRequestAsync({ projectName: new Configuration().URLPOLIZAS, apiName: "Sio4ActualizaReferenciaReciboAPI", dataJSON: data });
    } catch (e) {
      console.error("Exception in actualizaRefRecibos " + e);
    }
    this.setJsonData();
  }

  updatelogConsumo() {
    this.logConsumoFun.logConsumo();
  }

  creacionPolINBROKER() {
    try {
      let data = { polizaId: this.parameters[0].pol, worksiteId: new Configuration().worksiteIdEncr };
      this.requestService.postRequestAsync({ projectName: new Configuration().URLQuattroInbroker, apiName: "Sio4CreacionPolizaInbrokerAPI", dataJSON: data });

      //this.generaEstructuraBI(this.parameters[0].pol);
    } catch (error) {
      console.error("Error en creacionPolINBROKER " + error);
    }
  }

  generaEstructuraBI(poliza) {
    try {
      if(this.cocheSeguro.estructuraGrupoId > 0) {
        let data = {
          'estructura_id': this.cocheSeguro.estructuraGrupoId,
          'poliza_id': poliza
        };
        this.requestService.postRequest({projectName: new Configuration().BRIDGE_DATA_STRUCTURE_BI_AES, apiName: 'v1/bridge-data-structure-bi', dataJSON: data}).subscribe(
          result => {
            //console.log('result', result);
          },
          error => {
            console.error('error', error);
          }
        );
      }      
    } catch(error) {
      console.error("Error en generaEstructuraBI " + error);
    }
  }

  pagoExitoso(numero: number) {
    gtag({
      'event': 'ABBA_pago',
      'status': numero,      //valor NUMERICO de la propiedad Aut
      'polizaId': this.parameters[0].polid    //variable polizaId });
    });
  }
}
